// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__27jGE","col":"styles_col__37EGK"};